import { useRef } from 'react';

import PayAchButton from './PayAchButton';
import AchField from './components/AchField';
import { usePayroc } from './hooks/usePayroc';
import LoadingWrapper from './components/LoadingWrapper';
import SubmissionError from './components/SubmissionError';
import { useReportLoadError } from './hooks/useReportLoadError';
import { ACH_FIELDS, DEFAULT_ACH_FIELD_ROWS } from './lib/achFieldRows';

import './Payroc.scss';

const PayrocAchPayment = ({
  id,
  amount,
  handlePayment,
  validate,
  buttonText,
  hideButton = false,
  mode,
  secureTokenId,
  terminalPin,
  children,
  fieldRows,
  onError,
  onLoadError
}) => {
  const containerRef = useRef(null);
  const { isLoading, error, submitError, retry } = usePayroc({
    id,
    amount,
    validate,
    type: 'ach',
    containerRef,
    handlePayment,
    buttonText,
    hideButton,
    mode,
    secureTokenId,
    terminalPin,
    onError
  });
  useReportLoadError({ onLoadError, error, retry });

  return (
    <LoadingWrapper
      isLoading={isLoading}
      error={error}
      retry={retry}
      id={id}
      hideError={!!onLoadError}>
      <div
        ref={containerRef}
        className="ach-container payroc-form flex h-full w-full flex-col items-center justify-center gap-4 p-1">
        <SubmissionError message={submitError} />
        <div className="hosted-fields-message-container" id="hosted-fields-message-container"></div>
        {(fieldRows ?? DEFAULT_ACH_FIELD_ROWS).map((row) => (
          <div key={row.fields.join('-')} className={row.className}>
            {row.fields.map((field) => (
              <AchField
                key={field}
                field={field}
                label={ACH_FIELDS[field].label}
                wrapper={ACH_FIELDS[field].wrapper}
              />
            ))}
          </div>
        ))}
        {children}
        {!hideButton && <PayAchButton payrocId={id} />}
      </div>
    </LoadingWrapper>
  );
};

export default PayrocAchPayment;
